import { ZodType, z } from 'zod';

import { RfiFormValues } from './types';

export const RfiSchema: ZodType<RfiFormValues> = z.object({
  project_id: z
    .string({ required_error: '프로젝트를 선택해주세요.' })
    .min(1, '프로젝트를 선택해주세요.'),
  title: z.string({ required_error: '요청할 내용을 입력해주세요.' }).min(1, '제목을 입력해주세요.'),
  content: z
    .string({ required_error: '요청할 내용을 입력해주세요.' })
    .min(1, '요청할 내용을 입력해주세요.'),
  files: z.array(z.any()).optional(),
  assignee_id: z.string().optional().nullable(),
  dueDate: z.string().optional().nullable(),
});
